import React from 'react';
import { AppBar, Box, Tab, Tabs } from '@mui/material';

import { pricingTabs, setActivePriceGrid } from '../store/viewSlice';
import { HangerPriceGrid } from './hangers/HangerPriceGrid';
import { useAppDispatch, useAppSelector } from './hooks';
import { LumberPriceGrid } from './LumberPriceGrid';
import { PlatePriceGrid } from './PlatePriceGrid';
import { PriceTabLayout } from './PriceTabLayout';

export default function Content() {
  const dispatch = useAppDispatch();
  const lumberPriceCount = useAppSelector((state) => Object.keys(state.lumberPrices).length);
  const platePriceCount = useAppSelector((state) => Object.keys(state.platePrices).length);
  const hangerPriceCount = useAppSelector((state) => Object.keys(state.hangerPrices).length);
  const priceCounts = [lumberPriceCount, platePriceCount, hangerPriceCount] as const;

  const tabs = pricingTabs.map((tabTitle, index) => (
    <Tab
      key={tabTitle}
      label={
        <Box component="span">
          {tabTitle}{' '}
          <Box component="span" sx={{ fontStyle: 'italic' }}>
            ({priceCounts[index]})
          </Box>
        </Box>
      }
    />
  ));
  const handleTabChange = (_: React.ChangeEvent<{}>, value: number) => {
    dispatch(setActivePriceGrid(pricingTabs[value]));
  };
  const activePriceGrid = useAppSelector((state) => state.view.activePriceGrid);

  let activePriceGridComponent;
  switch (activePriceGrid) {
    case 'Lumber':
      activePriceGridComponent = <LumberPriceGrid />;
      break;
    case 'Plates':
      activePriceGridComponent = <PlatePriceGrid />;
      break;
    case 'Hangers':
      activePriceGridComponent = <HangerPriceGrid />;
      break;
    default:
      activePriceGridComponent = null;
  }

  return (
    <Box
      component="main"
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        pb: 3,
        bgcolor: 'canvas.main',
        flex: '1 1 auto',
        overflow: 'hidden',
        minWidth: 0, // So the Typography noWrap works
      }}
    >
      <AppBar
        enableColorOnDark
        position="static"
        elevation={0}
        sx={{
          bgcolor: 'appBar.main',
          backgroundImage: 'none',
          color: 'appBar.text',
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="inherit"
          variant="fullWidth"
          value={pricingTabs.indexOf(activePriceGrid)}
          onChange={handleTabChange}
          sx={{
            width: '100%',
            '& .MuiTab-root': {
              color: 'inherit',
              opacity: 0.72,
            },
            '& .Mui-selected': {
              opacity: 1,
            },
          }}
        >
          {tabs}
        </Tabs>
      </AppBar>

      <PriceTabLayout>{activePriceGridComponent}</PriceTabLayout>
    </Box>
  );
}
